/**
 * Automatically detects if we are in a local environment.
 * Render/Production provides REACT_APP_URL or API_URL.
 * Locally, these will be undefined.
 */
export const LOCAL_ENVIRONMENT = !process.env.REACT_APP_URL && !process.env.API_URL;

// Optional: Log it once so you can see it in the console
if (LOCAL_ENVIRONMENT) {
    console.log("%c 🟢 Running in LOCAL Mode ", "background: #222; color: #bada55; font-weight: bold;");
} else {
    console.log("%c 🚀 Running in PRODUCTION Mode ", "background: #004d40; color: #fff; font-weight: bold;");
}